<style lang="scss">
.yongxinProductionAllRowTable::before {
  z-index: inherit;
}

.yongxinProductionAllRowTable.el-table--enable-row-hover .el-table__body tr:hover>td {
  background: rgba(7, 53, 245, 1) !important;
}

.yongxinProductionAllRowTable.el-table {
  background-color: transparent;
}

.yongxinProductionAllRowTable.el-table--border:after,
.yongxinProductionAllRowTable.el-table--group:after,
.yongxinProductionAllRowTable.el-table:before {
  background-color: transparent;
}

.yongxinProductionAllRowTable.el-table tr {
  background-color: transparent;
}

.yongxinProductionAllRowTable.el-table td.gutter,
.yongxinProductionAllRowTable.el-table th.gutter {
  background: rgba(7, 53, 245, 1) !important;
}

// 滚动条的宽度
.yongxinProductionAllRowTable .el-table__body-wrapper::-webkit-scrollbar {
  width: 2px; // 横向滚动条
}

// 滚动条的滑块
.yongxinProductionAllRowTable .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #419fff;
  border-radius: 2px;
}

// .yongxinProductionAllRowTable .el-table__body-wrapper::-webkit-scrollbar-track {
// 	/*滚动条里面轨道*/
// 	border-radius: 2px;
// 	background: #1D1D24;
// }</style>

<style scoped>
.biankuang {
  border: 4px solid rgba(108, 167, 255, 1);
  border-radius: 5px;
  box-shadow: 0px 0px 30px 0px rgba(45, 53, 255, 1) inset;
  box-shadow: 0px 0px 80px 0px rgba(45, 53, 255, 1) inset;
}

.yongxinSmallTitle {
  background-image: url(../../../../../../../assets/img/web/yongxin/small_title_bg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
</style>
<template>
  <div ref="container" style="overflow: auto;height: 100%;position: relative;padding: 0px 20px 10px 20px; background: rgba(3, 0, 108, 1)">
    <div class="biankuang">
      <div ref="titleBar" class="titleBar" style="display: flex;justify-content: space-between;align-items:center ;padding-bottom: 10px;">
        <div class="yongxinSmallTitle" style="width: 100%;height: 40px;color:white;display:flex;justify-content:center;align-items:center;font-size:20px">
          实时监测
        </div>
      </div>
      <div :style="{ height: contentHeight + 'px' }">
        <el-table ref="table" class="yongxinProductionAllRowTable" :data="progresses" style="width: 100%" :max-height="contentHeight" :row-style="{ height: rowHeight + 'px' }" :cell-style="{ padding: 0 + 'px', borderColor: 'rgba(7, 53, 245, 1)', color: '#FFFFFF', 'font-size': '16px' }" :header-cell-style="{ background: 'rgba(7, 53, 245, 1)', color: 'white', padding: '0px', height: '42px', borderColor: 'transparent', 'font-size': '16px' }" cell-class-name="cell-class-name">
          <el-table-column prop="equipmentName" :label="$t('shebeimingcheng')"> </el-table-column>
          <el-table-column :label="$t('zhuangtai')">
            <template slot-scope="scope">
              <div style="line-height: 28px;">
                <span v-if="scope.row.equipmentStatus !== null" :style="{ color: status[scope.row.equipmentStatus].color, 'border-color': status[scope.row.equipmentStatus].color, background: status[scope.row.equipmentStatus].tagBg }" style="border-radius: 2px;font-size: 14px;padding: 3px 8px;box-sizing: border-box;border: 1px solid;">{{ status[scope.row.equipmentStatus].title }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="targetOutput" :label="$t('生产目标')"> </el-table-column>
          <el-table-column prop="actualOutput" :label="$t('生产实绩')"> </el-table-column>
          <el-table-column :label="$t('达成率')">
            <template slot-scope="scope">
              {{ parseFloat((scope.row.achievementRate ? scope.row.achievementRate : 0) * 100).toFixed(1) }}%
            </template>
          </el-table-column>
          <el-table-column :label="$t('良品数量')">
            <template slot-scope="scope">
              {{ scope.row.qualifiedQuantity }}
            </template>
          </el-table-column>
          <el-table-column prop="rejectQuantity" :label="$t('不良品数量')"> </el-table-column>

          <el-table-column :label="$t('不良率')">
            <template slot-scope="scope">
              {{ parseFloat((scope.row.rejectRate ? scope.row.rejectRate : 0) * 100).toFixed(1) }}%
            </template>
          </el-table-column>
          <el-table-column prop="leftQuantity" :label="$t('订单剩余数')"> </el-table-column>

          <el-table-column :label="$t('标准/实时C/T')">
            <template slot-scope="scope">
              {{ parseFloat(scope.row.standardCycle ? scope.row.standardCycle : 0).toFixed(1) }}/
              {{ parseFloat(scope.row.actualCycle ? scope.row.actualCycle : 0).toFixed(1) }}
            </template>
          </el-table-column>



          <el-table-column :label="$t('稼动率')">
            <template slot-scope="scope">
              {{ parseFloat((scope.row.utilizationRate ? scope.row.utilizationRate : 0) * 100).toFixed(1) }}%
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
// import {
// 	Graph as x6
// } from "@antv/x6";

// import {
// 	DagreLayout as x6layout
// } from '@antv/layout'
export default {
  name: 'web_monitor_production_all_row',
  components: {},
  data() {
    return {
      listSize: 0,



      status: {
        '0': {
          color: 'rgba(58, 220, 255, 1)',
          title: this.$t('yunxing'),
          tagBg: 'rgba(58, 220, 255, 0.2)',
          cardBg: 'linear-gradient(270deg, #6FE6D0 0%, #356DFB 100%)'
        },
        '1': {
          color: 'rgba(255, 200, 58, 1)',
          title: this.$t('kongxian'),
          tagBg: 'rgba(255, 200, 58, 0.2)',
          cardBg: 'linear-gradient(270deg, #FFD057 0%, #E49155 100%)'
        },
        '3': {
          color: 'rgba(255, 58, 117)',
          title: this.$t('guzhang'),
          tagBg: 'rgba(255, 58, 117, 0.2)',
          cardBg: 'linear-gradient(270deg, #E455D6 0%, #FF3A75 100%)'
        },
        '-1': {
          color: 'rgba(170, 179, 204, 1)',
          title: this.$t('lixian'),
          tagBg: 'rgba(170, 179, 204, 0.2)',
          cardBg: 'linear-gradient(270deg, #858FA3 0%, #333333 100%)'
        },

      },

      // status: {
      //   '1': {
      //     color: 'rgba(65, 159, 255, 1)',
      //     title: this.$t('xinjian'),
      //     tagBg: 'rgba(65, 159, 255, 0.2)',
      //     cardBg: 'linear-gradient(180deg, #2686E9 0%, rgba(18, 18, 18, 0) 100%)'
      //   },
      //   '2': {
      //     color: 'rgba(65, 159, 255, 1)',
      //     title: this.$t('fafang'),
      //     tagBg: 'rgba(65, 159, 255, 0.2)',
      //     cardBg: 'linear-gradient(180deg, #2686E9 0%, rgba(18, 18, 18, 0) 100%)'
      //   },
      //   '3': {
      //     color: '#39F16D',
      //     title: this.$t('shengchanzhong'),
      //     tagBg: 'rgba(57, 241, 109, 0.2)',
      //     cardBg: 'linear-gradient(180deg, #35D258 0%, rgba(18, 18, 18, 0) 100%)'
      //   },
      //   '4': {
      //     color: 'rgba(255, 58, 94, 1)',
      //     title: this.$t('zanting'),
      //     tagBg: 'rgba(255, 58, 94, 0.2)',
      //     cardBg: 'linear-gradient(180deg, #FF3A5E 0%, rgba(18, 18, 18, 0) 100%)'
      //   },
      //   '5': {
      //     color: '#39F16D',
      //     title: this.$t('shougongxuwangong'),
      //     tagBg: 'rgba(57, 241, 109, 0.2)',
      //     cardBg: 'linear-gradient(180deg, #35D258 0%, rgba(18, 18, 18, 0) 100%)'
      //   },
      //   '6': {
      //     color: '#39F16D',
      //     title: this.$t('wangong'),
      //     tagBg: 'rgba(57, 241, 109, 0.2)',
      //     cardBg: 'linear-gradient(180deg, #35D258 0%, rgba(18, 18, 18, 0) 100%)'
      //   },
      //   '7': {
      //     color: 'rgba(153, 160, 173, 1)',
      //     title: this.$t('guanbi'),
      //     tagBg: 'rgba(153, 160, 173, 0.2)',
      //     cardBg: 'linear-gradient(180deg, #A5A5A5 0%, rgba(18, 18, 18, 0) 100%)'
      //   },
      //   '8': {
      //     color: 'rgba(255, 200, 58, 1)',
      //     title: this.$t('yidiaobo'),
      //     tagBg: 'rgba(255, 200, 58, 0.2)',
      //     cardBg: 'linear-gradient(180deg, #FA9D2D 0%, rgba(18, 18, 18, 0) 100%)'
      //   }
      // },
      interval: null,
      timmer: null,
      contentHeight: 0,
      rowHeight: 0,
      progresses: [],
      isStopListScroll: false
    };
  },
  created() {
    this.timmer = setInterval(() => {
      this.listProductionProgress();
    }, 120000);
    this.listProductionProgress();
  },
  mounted() {
    this.resize();

    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
    this.setAutoScroll();
  },
  destroyed() {
    clearInterval(this.timmer);
    clearInterval(this.interval);
  },

  activated() {
    setTimeout(() => {
      this.initPie(this.showMode);
    }, 500);
  },
  watch: {},
  computed: {
    sumProductAndPlanNumber() {
      let planQuantity = 0;
      let productionQuantity = 0;
      for (var i = 0; i < this.progresses.length; i++) {
        planQuantity += this.progresses[i].planQuantity;
        productionQuantity += this.progresses[i].productionQuantity;
      }
      return [productionQuantity, planQuantity, ((productionQuantity / planQuantity) * 100).toFixed(1) + '%'];
    }
  },
  methods: {
    setProductionAll() {
      let monitorSetting = localStorage.getItem('MONITOR_SETTING');
      if (!monitorSetting) {
        this.monitorSetting = {};
      } else {
        this.monitorSetting = JSON.parse(monitorSetting);
      }
    },
    setAutoScroll() {
      if (this.interval) {
        clearInterval(this.interval);
      }
      const listDiv = this.$refs.table.bodyWrapper;
      this.interval = setInterval(() => {
        if (!this.store.state.is_monitor_full) {
          return;
        }
        if (!this.isStopListScroll) {
          listDiv.scrollTop += 1 / window.devicePixelRatio + 0.05;
          if (listDiv.clientHeight + listDiv.scrollTop >= listDiv.scrollHeight) {
            this.isStopListScroll = true;
            setTimeout(() => {
              if (listDiv.clientHeight + listDiv.scrollTop >= listDiv.scrollHeight) {
                listDiv.scrollTop = 0;
              }
              this.isStopListScroll = false;
            }, 5000);
          }
        }
      }, 100);
    },

    async listProductionProgress() {
      let response = await this.http.get('/custom/yongxin/production/comprehensive/board', {
        params: {}
      });
      this.progresses = response.data.resList;
      this.listSize = this.progresses.length;
    },

    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (this.$refs.titleBar == null) {
          return;
        }
        this.contentHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 20;
        this.rowHeight = (this.contentHeight - 42 - 5) / 8;
      }, 800);
    }
  }
};
</script>
